import { createContext, useContext } from 'react';

export type Config = { [key: string]: any };

export const AppContext = createContext<{
  config: Config | null,
  refetchConfig: any,
  getPermissions: (keyAccess: string) => any;
  getLicenseLimits: () => { users: number; patients: number; clinics: number; };
}>({ config: null, getPermissions: () => {}, getLicenseLimits: () => ({
  users: 0, patients: 0, clinics: 0,
}), refetchConfig: () => {}});

export const useConfig = () => useContext(AppContext);
